// TODO: Need Audit
//
import $ from "jquery";
import LateralEvent from './lateral_event';

export default class LarvaCachedEvent extends LateralEvent {
  getRecommendations(videoId) {
    var count = $("#reco_gravity").data('count') || 20;
    var targetUrl = 'larva_related';

    $.ajax({
      url: `/${targetUrl}/${videoId}`,
      data: { count: count },
      success: this.recommendationCallback.bind(this)
    });
  }

  recoName() {
    return 'larva_related';
  }

  fallbackName() {
    return 'fallback_larva_related';
  }
}
